import { api, ApiError } from '../api.js';
import { toast } from '../components/toast.js';
import { navigate } from '../router.js';

const KEY = 'triviana.pending_invite';

/**
 * Resume an invite-link join that was deferred while the user authed.
 *
 * `play.js renderInviteJoin` stashes the invite code in sessionStorage when
 * the user hits a /play/invite/:code URL while unauthenticated. Signup +
 * login call this helper after a successful auth — if there's a pending
 * invite, we POST /match/invite/join and land them straight in the match
 * room, skipping onboarding entirely.
 *
 * Returns true iff a redirect was performed (caller should NOT navigate).
 */
export async function resumePendingInvite() {
  const code = sessionStorage.getItem(KEY);
  if (!code) return false;
  sessionStorage.removeItem(KEY);  // single-shot — no replay on next signup
  try {
    const match = await api('/match/invite/join', { method: 'POST', body: { code } });
    toast.success('Joining match…');
    navigate(`/match/${match.id}`);
    return true;
  } catch (err) {
    // Code invalid / already used / opponent already there → fall through to
    // the normal post-auth landing. The error itself is shown so the user
    // knows the invite didn't take.
    const msg = err instanceof ApiError ? err.message : 'Could not join match.';
    toast.error(`Invite link: ${msg}`);
    return false;
  }
}
